import React, { useState, useEffect } from 'react';
import { Button, Dialog, Box, makeStyles, DialogTitle, DialogContent } from '@material-ui/core';
import { CircularProgress } from '@material-ui/core';
import { API_EXTRANET, CORP_BLUE } from 'config/config';
import axios from 'axios';
import { toast } from '@jumbo/components/custom/Toast';

const addStyle = makeStyles(theme => ({
  dialogRoot: {
    position: 'relative',
  },
  dialogTitleRoot: {
    backgroundColor: CORP_BLUE,
    '& .MuiTypography-h6': {
      fontSize: 16,
      color: 'white',
    },
  },
  num: {
    display: 'block',
    width: '100%',
  },
}));

const defaultReclamo = {
  n_reclamo: '',
};

const GetReclamo = ({ openDialog = false, close, submit, reclamo = defaultReclamo }) => {
  const classes = addStyle();
  const [num, setNum] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (reclamo) {
      setNum(reclamo.n_reclamo ? reclamo.n_reclamo : 'nulo');
    }
  }, [reclamo]);

  const onCloseDialog = event => {
    close();
  };
  const onSubmitClick = () => {
    setLoading(true);
    /* const user = JSON.parse(sessionStorage.getItem('user')); */
    let token = JSON.parse(sessionStorage.getItem('user')).token;
    const URL = `${API_EXTRANET}api/v1/userIf/${num}`;
    axios
      .delete(URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {},
      })
      .then(res => {
        toast.success('Reclamo quitado correctamente.');
        setLoading(false);
        submit();
      })
      .catch(err => {
        console.log(err);
        toast.error('Error al quitar el reclamo.');
        setLoading(false);
      });
  };

  return (
    <Dialog open={openDialog} onClose={onCloseDialog}>
      <DialogTitle className={classes.dialogTitleRoot}>
        <label className={classes.num}> Reclamo N° {num} </label>
      </DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
          ¿Esta seguro que desea quitar este reclamo?
        </Box>
        <Box display="flex" justifyContent="flex-end" mb={4}>
          <Button onClick={onCloseDialog} disabled={loading}>
            &nbsp;Cancelar&nbsp;
          </Button>
          <Box ml={2}>
            <Button variant="outlined" color="primary" onClick={onSubmitClick} disabled={loading}>
              {loading ? <CircularProgress color="inherit" style={{ height: '22px', width: '22px' }} /> : 'Quitar'}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default GetReclamo;
